// METIS Hub wording — namespace "glossary" (en), 209 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/glossary.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const glossary: Record<string, string> = {
  "glossary.kicker": "{n} terms · {core} core",
  "glossary.desc": "Plain words in large type, with the original term and a definition. Tapping a dotted-underlined term anywhere brings you here.",
  "glossary.search.label": "Find a term",
  "glossary.search.ph": "Plain word, original term, or variable name (e.g. cache, input_tokens)",
  "glossary.search.hint": "Press Enter to keep it in recent searches · Esc clears · Korean initial consonants work too",
  "glossary.search.clear": "Clear search",
  "glossary.recent": "Recent searches",
  "glossary.recent.clear": "Clear all",
  "glossary.recent.local": "Kept in this browser only",
  "glossary.recent.cleared": "Recent searches cleared",
  "glossary.popular": "Often looked up",
  "glossary.cat.label": "Category",
  "glossary.cat.all": "All",
  "glossary.index.label": "A–Z index",
  "glossary.index.button": "A–Z index",
  "glossary.index.buttonOn": "Index: {l}",
  "glossary.index.clear": "Clear index",
  "glossary.index.sheet": "Find by first letter",
  "glossary.index.letter": "{n|term starts|terms start} with “{l}”",
  "glossary.status.browse": "Showing the {core} core terms by category first. {extra} supporting terms open with “Show more”.",
  "glossary.status.cat": "Showing {core} core terms of {n} in {cat} first.",
  "glossary.status.query": "{n|term matches|terms match} “{q}”",
  "glossary.status.queryCat": "{n|term matches|terms match} “{q}” · {cat} only",
  "glossary.status.letter": "{n|term starts|terms start} with “{l}”",
  "glossary.status.letterCat": "{n|term starts|terms start} with “{l}” · {cat} only",
  "glossary.sec.count": "{core} core · {extra} supporting",
  "glossary.sec.system": "Words this system coined for its screens. They link to manual sections (coming soon) instead of outside documents.",
  "glossary.more": "Show {n} more supporting terms",
  "glossary.less": "Hide supporting terms",
  "glossary.item.example": "Example",
  "glossary.item.related": "Related terms",
  "glossary.item.screens": "Used on",
  "glossary.item.ext": "External explanation",
  "glossary.item.detail": "Open details",
  "glossary.item.edit": "Edit",
  "glossary.item.hidden": "Hidden · admins only",
  "glossary.match.plain": "Matches the plain word",
  "glossary.match.chosung": "Matches Korean initials",
  "glossary.match.term": "Matches the original term",
  "glossary.match.alias": "Matches another name",
  "glossary.match.raw": "Matches the original name",
  "glossary.match.def": "Found in the definition",
  "glossary.match.renamed": "Screens call it “{plain}”",
  "glossary.none.title": "No term matches “{q}”",
  "glossary.none.desc": "Check the spelling or try a shorter word.",
  "glossary.none.similar": "Similar terms",
  "glossary.none.dropCat": "{n} without the “{cat}” filter",
  "glossary.none.dropLetter": "{n} without the index",
  "glossary.empty.title": "No terms to show",
  "glossary.empty.desc": "Glossary data hasn’t arrived yet. Explanations of dotted-underlined terms still work on every screen.",
  "glossary.error.title": "Couldn’t load the glossary",
  "glossary.error.desc": "Try again in a moment. Explanations of dotted-underlined terms still work on every screen.",
  "glossary.allTerms": "Show all terms",
  "glossary.foot": "Definitions make sense without the external links. External explanations open in a new tab and never receive company addresses or user info.",
  "glossary.foot.check": "External link check: weekly · last {last} · next {next}",
  "glossary.foot.cov": "What each tool and usage method can and can’t record:",
  "glossary.foot.covLink": "see What gets recorded",
  "glossary.ext.checked": "last checked {date}",
  "glossary.ext.none": "No external explanation for this term. The definition stands on its own.",
  "glossary.ext.otherLang": "{lang} document",
  "glossary.d.core": "Core term",
  "glossary.d.extra": "Supporting term",
  "glossary.d.orig": "Original term: {term}",
  "glossary.d.q.def": "What does “{plain}” mean?",
  "glossary.d.tech.def": "Definition · example · original names",
  "glossary.d.def": "Definition",
  "glossary.d.example": "Example",
  "glossary.d.raw": "Original names",
  "glossary.d.rawHint": "Records and settings files show it under these names (search finds them too).",
  "glossary.d.q.related": "What else is good to know?",
  "glossary.d.tech.related": "{n|related term|related terms}",
  "glossary.d.relatedNone": "No linked terms.",
  "glossary.d.q.screens": "Which screens show it?",
  "glossary.d.tech.screens": "Used on {n|screen|screens}",
  "glossary.d.screensNone": "A general term not tied to a particular screen.",
  "glossary.d.screenLocked": "Not available to your current role",
  "glossary.d.screenLogin": "Sign-in screen",
  "glossary.d.q.ext": "Where can I read more?",
  "glossary.d.tech.ext": "External explanation · source · language · last checked",
  "glossary.d.ext.source": "Source",
  "glossary.d.ext.lang": "Document language",
  "glossary.d.ext.checked": "Last checked",
  "glossary.d.ext.manual": "Manual section",
  "glossary.d.ext.manualSoon": "{ref} · link hidden until it’s ready",
  "glossary.d.ext.rule": "External explanations open in a new tab and never receive company addresses or user info. If a link breaks, only the link is hidden — the definition stays.",
  "glossary.d.copy": "Copy link",
  "glossary.d.copied": "Term link copied",
  "glossary.d.oldSlug": "You came in through the old address ({old}); it now opens as {slug}.",
  "glossary.d.nav": "Other terms in this category",
  "glossary.d.prev": "Previous term",
  "glossary.d.next": "Next term",
  "glossary.d.emptyWhat": "This term’s explanation hasn’t arrived yet.",
  "glossary.d.emptyNot": "It doesn’t mean the term is missing. Try again in a moment.",
  "glossary.d.hiddenNote": "This term is hidden from the list. People coming in through an old link still see it.",
  "glossary.u.title": "We couldn’t find that term",
  "glossary.u.desc": "No term has the address “{slug}”. Here are terms found by the words in the address.",
  "glossary.u.q": "Is one of these what you wanted?",
  "glossary.u.tech": "{n|term|terms} found by address words",
  "glossary.u.none": "Nothing found by the address words either. Try searching the glossary.",
  "glossary.u.back": "Open the full glossary",
  "glossary.a.add": "Add a term",
  "glossary.a.links": "Link check results",
  "glossary.a.linksBad": "{n} to check",
  "glossary.ls.ok": "OK",
  "glossary.ls.check_needed": "Needs checking",
  "glossary.ls.moved": "Address moved",
  "glossary.ls.pending": "Coming soon",
  "glossary.l.kicker": "Glossary admin",
  "glossary.l.title": "External link check results",
  "glossary.l.sum": "Of {n} explanation and manual links, {ok} are OK, {bad} need attention and {p} are awaiting a check.",
  "glossary.l.when": "Checked weekly · last {last} · next {next}",
  "glossary.l.rule": "A link is OK when it returns HTTP 200, its page title contains the expected title, and there is no “page not found” marker.",
  "glossary.l.col.term": "Term",
  "glossary.l.col.host": "Address",
  "glossary.l.col.result": "Result",
  "glossary.l.col.why": "Why",
  "glossary.l.why.title": "Page title didn’t match (“page not found” marker detected)",
  "glossary.l.now": "Check now",
  "glossary.l.checking": "Checking…",
  "glossary.l.done": "Check finished · {n} to check",
  "glossary.l.donePending": "Check finished · {n} need attention · {p} awaiting a check",
  "glossary.l.progress": "Checking links {i}/{n}",
  "glossary.l.bg": "[Check now] closes this window and checks in the background. Progress shows in the notification at the bottom.",
  "glossary.l.noFail": "No links need checking.",
  "glossary.l.pending": "Some links are awaiting a check. Results are not yet available for every link.",
  "glossary.l.userView": "Users see the definition as usual; only this link is hidden.",
  "glossary.l.fix": "Edit",
  "glossary.e.kicker": "Edit term · {slug}",
  "glossary.e.newKicker": "Glossary admin",
  "glossary.e.title": "Edit “{plain}”",
  "glossary.e.titleNew": "Add a term",
  "glossary.e.tab.label": "Term editing steps",
  "glossary.e.tab.edit": "Edit",
  "glossary.e.tab.preview": "Preview",
  "glossary.e.tab.history": "History",
  "glossary.e.slug": "Address name (slug)",
  "glossary.e.slugHint": "Lowercase letters, digits and hyphens only. It can’t be changed later.",
  "glossary.e.slugFixed": "The address name can’t change ({slug}). If the name changes, add it as another name (alias).",
  "glossary.e.plainKo": "Plain word (Korean)",
  "glossary.e.plainEn": "Plain word (English)",
  "glossary.e.plainLocked": "Linked to the label dictionary, so it can’t be changed here. Change it in the label dictionary so screen labels and the glossary stay in sync.",
  "glossary.e.termKo": "Original term (Korean)",
  "glossary.e.termEn": "Original term (English)",
  "glossary.e.defKo": "Definition (Korean)",
  "glossary.e.defEn": "Definition (English)",
  "glossary.e.defHint": "1–2 sentences · understandable without links · **bold**, lists (start a line with - ) and `code` work · no HTML or links",
  "glossary.e.exKo": "Example (Korean)",
  "glossary.e.exEn": "Example (English)",
  "glossary.e.aliases": "Other names (aliases)",
  "glossary.e.aliasesHint": "Separate with commas. Used for search only, never shown on screen.",
  "glossary.e.related": "Related terms (address names)",
  "glossary.e.relatedHint": "Separate with commas, e.g. token, cache-read",
  "glossary.e.screens": "Used on",
  "glossary.e.category": "Category",
  "glossary.e.core": "Core term",
  "glossary.e.coreDesc": "Shown first on the glossary page",
  "glossary.e.urlKo": "External explanation (Korean document)",
  "glossary.e.urlEn": "External explanation (English document)",
  "glossary.e.urlHint": "https addresses only. Korean screens show the Korean document first, English screens the English one. Saving runs one link check right away.",
  "glossary.e.source": "Source name",
  "glossary.e.expected": "Expected page title",
  "glossary.e.err.required": "Required",
  "glossary.e.err.html": "No HTML or links (bold, lists and code formatting are fine)",
  "glossary.e.err.https": "Only addresses starting with https are accepted",
  "glossary.e.err.slug": "Lowercase letters, digits and hyphens only",
  "glossary.e.err.slugTaken": "That address name already exists",
  "glossary.e.err.related": "Unknown terms: {list}",
  "glossary.e.err.fix": "{n|field needs|fields need} fixing",
  "glossary.e.save": "Save",
  "glossary.e.add": "Add",
  "glossary.e.hide": "Hide",
  "glossary.e.unhide": "Show again",
  "glossary.e.hideLocked": "The label dictionary points to this term, so it can’t be hidden.",
  "glossary.e.saved": "Saved · recorded in the access & change log",
  "glossary.e.savedCheck": "Saved · the link check passed, so the external link is shown",
  "glossary.e.noChange": "Nothing changed",
  "glossary.e.hidden": "Term hidden from the list",
  "glossary.e.unhidden": "Term shown again",
  "glossary.e.added": "Term added · recorded in the access & change log",
  "glossary.e.preview": "This is how it appears in the glossary list for users, formatting included.",
  "glossary.h.seed": "Initial data (term seed)",
  "glossary.h.edit": "Edited",
  "glossary.h.revert": "Reverted",
  "glossary.h.hide": "Hidden",
  "glossary.h.unhide": "Shown again",
  "glossary.h.current": "Current version",
  "glossary.h.fields": "Changed: {list}",
  "glossary.h.toThis": "Revert to this version",
  "glossary.h.reverted": "Reverted to the earlier version · recorded in the access & change log",
  "glossary.h.note": "Every change is also kept in the access & change log (who, when, which fields).",
  "glossary.e.pcOnly": "Please edit on a computer",
  "glossary.e.pcOnlyDesc": "Terms are edited on a wide screen. Here you can only read the current content.",
  "glossary.f.plainKo": "Plain word (KO)",
  "glossary.f.plainEn": "Plain word (EN)",
  "glossary.f.term": "Original term (KO)",
  "glossary.f.termEn": "Original term (EN)",
  "glossary.f.defKo": "Definition (KO)",
  "glossary.f.defEn": "Definition (EN)",
  "glossary.f.exKo": "Example (KO)",
  "glossary.f.exEn": "Example (EN)",
  "glossary.f.aliases": "Other names",
  "glossary.f.related": "Related terms",
  "glossary.f.screens": "Used on",
  "glossary.f.category": "Category",
  "glossary.f.core": "Core",
  "glossary.f.urlKo": "External address (KO)",
  "glossary.f.urlEn": "External address (EN)",
  "glossary.f.source": "Source",
  "glossary.f.expected": "Expected title",
  "glossary.f.hidden": "Hidden",
  "glossary.f.noUrl": "Not set",
};

export default glossary;
